import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, useAuth } from '@/App';
import axios from 'axios';
import { toast } from '@/components/ui/sonner';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function VerifyEmailChange() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const { data } = await axios.get(`${API}/auth/verify-email-change/${token}`);
        setStatus('success');
        setMessage(data.message);
        setNewEmail(data.new_email || '');
        toast.success('Email changed successfully!');
      } catch (err) {
        setStatus('error');
        setMessage(err?.response?.data?.detail || 'Failed to verify email change');
        toast.error(err?.response?.data?.detail || 'Verification failed');
      }
    };
    if (token) verify();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="verify-email-change-page">
      <div className="max-w-md w-full text-center space-y-6">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-primary animate-spin" />
            <h2 className="text-xl font-semibold">Verifying your new email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 mx-auto text-green-500" />
            <h2 className="text-2xl font-bold">Email Updated!</h2>
            <p className="text-muted-foreground">
              Your email has been changed to <strong>{newEmail}</strong>. 
              Please log in again with your new email.
            </p>
            <Button onClick={() => navigate('/')} className="rounded-full" data-testid="go-home-btn">
              Go to Home
            </Button>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 mx-auto text-red-500" />
            <h2 className="text-2xl font-bold">Verification Failed</h2>
            <p className="text-muted-foreground">{message}</p>
            <Button onClick={() => navigate('/profile')} variant="outline" className="rounded-full" data-testid="go-profile-btn">
              Go to Profile
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
